import { localeValues } from 'common/constants/localeTypes'
import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next'

export const locales = Object.keys(localeValues)

const assetsHost = process.env.EDITOR_ASSETS_HOST || ''
const codeVersion = process.env.CODE_VERSION || ''

const i18nInitPromise = i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .use(ICU)
  .init({
    ns: ['common', 'client'],
    defaultNS: 'client',
    load: 'languageOnly',
    debug: false,
    fallbackLng: {
      ua: ['uk'],
      dk: ['da'],
      jp: ['ja'],
      default: ['en'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: `${assetsHost}/assets/i18n/{{ns}}/{{lng}}.json`,
      queryStringParams: codeVersion ? { v: codeVersion } : {},
    },
  })

export { i18nInitPromise }
export default i18n
